// if ( objects.is_front_page ) {
	
	if ( document.querySelector('.swiper-partenaires')) {
		const swiper_partenaires = new Swiper('.swiper-partenaires', {
			grabCursor: true,
			centeredSlides: true,
			loop: true,
			spaceBetween: 20,
			slidesPerView: 2,
			autoplay: {
				delay: 1000,
			  },
			breakpoints: {
				472: {
					spaceBetween: 15,
				  	slidesPerView: 3,
				},
				576: {
					spaceBetween: 15,
					slidesPerView: 3,
				  },
				768: {
					spaceBetween: 40,
				  	slidesPerView: 4,
				},
				992: {
					spaceBetween: 15,
				  	slidesPerView: 5,
				},
				1200: {
					slidesPerView: 7,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next.swiper-partenaires-button',
				prevEl: '.swiper-button-prev.swiper-partenaires-button',
			}
		})
	}

	//register the plugin (just once)
	// gsap.registerPlugin(MotionPathPlugin);
// }

AOS.init()